import Button from '@mui/material/Button';

export default function IconButton(props) {
  return (
    <Button variant={props.variant}
      color={props.color}
      title={props.title || ""}
      onClick={props.onClick}
      style={{ minWidth: props.width, maxWidth: props.width, minHeight: props.width, maxHeight: props.width, marginLeft: props.margin || 0, marginTop: props.marginTop || 0 }}
      disabled={props.disabled}
    >
      {props.icon}
    </Button>
  );
}
